module.exports = __webpack_public_path__ + "img/beneficios.e9443c62.png";